"use client";

import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/** Every cache the timeline page reads reservations from. */
const TIMELINE_RESERVATION_QUERY_KEYS = [
  // The calendar grids, per office, range and room selection.
  ["timeline-events"],
  // The gantt, which asks for a whole resource type across many days.
  ["timeline-gantt-overview"]
];

/**
 * Returns a callback that invalidates every cached timeline query that holds
 * reservations, regardless of office, date range, or view. Use this after
 * mutations that affect reservations (create/edit/cancel) so the timeline
 * picks up the change immediately instead of waiting for the background
 * refetch.
 *
 * Both layouts have to be listed: the reservation modal is shared between
 * them, so a booking edited from a gantt bar would otherwise leave the chart
 * showing what it looked like before.
 */
export const useInvalidateTimelineEvents = () => {
  const queryClient = useQueryClient();
  return useCallback(async () => {
    await Promise.all(
      TIMELINE_RESERVATION_QUERY_KEYS.map((queryKey) =>
        queryClient.invalidateQueries({ queryKey })
      )
    );
  }, [queryClient]);
};
